<template>
  <main-template>
    <v-row>
      <v-col cols="12">
        <span class="text-h4">Justificar Falta</span>
        <e-help-tooltip
          text="Consulte suas justificativas de falta, acompanhe a análise e envie novas solicitações."
        />
        <v-col cols="12" class="pt-2 px-0">
          <div class="d-flex justify-space-between">
            <v-btn color="success" class="mr-2" @click="abrirCriar"> Criar Justificativa </v-btn>
            <v-text-field
              v-model="search"
              class="ml-2 search-input"
              append-icon="mdi-magnify"
              label="Pesquisar..."
              solo
              dense
              single-line
              hide-details
            />
          </div>
        </v-col>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <v-data-table
          :headers="table.headers"
          :items="justificativas"
          :loading="carregando"
          :items-per-page="10"
          hide-default-footer
          class="elevation-1"
        >
          <template v-slot:item.tipo="{ item }">
            {{ tipoLabel(item.tipo) }}
          </template>
          <template v-slot:item.periodo="{ item }">
            {{
              item.data_inicial
                ? `${formatarData(item.data_inicial)} a ${formatarData(item.data_final)}`
                : "---"
            }}
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip small label :color="statusInfo(item.status).color" text-color="white">
              {{ statusInfo(item.status).label }}
            </v-chip>
          </template>
          <template v-slot:item.historico="{ item }">
            <v-btn icon small aria-label="Ver histórico" @click="abrirHistorico(item)">
              <v-icon>mdi-chevron-up</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip color="blue-grey" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  x-small
                  class="ml-1"
                  color="blue-grey lighten-3"
                  aria-label="Editar"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="item.status !== 'AGUARDANDO'"
                  @click="abrirEditar(item.id)"
                >
                  <v-icon small>fa fa-edit</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip color="error" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  x-small
                  class="ml-1"
                  color="error"
                  aria-label="Deletar"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="item.status !== 'AGUARDANDO'"
                  @click="destroy(item.id)"
                >
                  <v-icon small>fa fa-trash</v-icon>
                </v-btn>
              </template>
              <span>Deletar</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <e-paginate
          :current_page="paginate.current_page"
          :last_page="paginate.last_page"
          :pageNumber="pageNumber"
          :search="search"
          @changeActionResponse="loadData"
        ></e-paginate>
      </v-col>
    </v-row>

    <FormJustificativaFaltaDialog
      v-model="dialogForm"
      :editing-id="editingId"
      @salvo="loadData(pageNumber)"
    />
    <HistoricoJustificativaFaltaDialog
      v-model="dialogHistorico"
      :solicitacao="historicoSelecionado"
    />
  </main-template>
</template>

<script>
import FormJustificativaFaltaDialog from "./FormJustificativaFaltaDialog.vue";
import HistoricoJustificativaFaltaDialog from "./HistoricoJustificativaFaltaDialog.vue";

const STATUS = {
  AGUARDANDO: { label: "Aguardando", color: "grey" },
  CONFIRMADO: { label: "Confirmado", color: "green" },
  REJEITADO: { label: "Rejeitado", color: "red" },
};

const TIPOS_LABEL = {
  SAUDE: "Motivos de saúde",
  VIAGEM: "Motivos de viagem",
  ATESTADO_MEDICO: "Atestado médico",
  OUTROS: "Outros",
};

export default {
  components: {
    FormJustificativaFaltaDialog,
    HistoricoJustificativaFaltaDialog,
  },
  data() {
    return {
      justificativas: [],
      carregando: false,
      search: "",
      pageNumber: 0,
      paginate: {
        current_page: 0,
        last_page: 0,
      },
      dialogForm: false,
      editingId: null,
      dialogHistorico: false,
      historicoSelecionado: null,
      table: {
        headers: [
          { text: "ID", value: "id" },
          { text: "Justificativa", value: "tipo" },
          { text: "Data da Justificativa", value: "periodo" },
          { text: "Status", value: "status" },
          { text: "Histórico", value: "historico", sortable: false },
          { text: "Ações", value: "actions", sortable: false, width: "120px" },
        ],
      },
    };
  },
  watch: {
    search() {
      this.loadData(0);
    },
  },
  methods: {
    statusInfo(status) {
      return STATUS[status] || { label: "- - -", color: "grey" };
    },
    tipoLabel(tipo) {
      return TIPOS_LABEL[tipo] || tipo;
    },
    formatarData(data) {
      if (!data) return "---";
      const [ano, mes, dia] = data.split("-");
      return `${dia}/${mes}/${ano}`;
    },
    abrirCriar() {
      this.editingId = null;
      this.dialogForm = true;
    },
    abrirEditar(id) {
      this.editingId = id;
      this.dialogForm = true;
    },
    abrirHistorico(item) {
      this.historicoSelecionado = item;
      this.dialogHistorico = true;
    },
    async loadData(pageNumber = 0) {
      this.pageNumber = pageNumber;
      this.carregando = true;
      try {
        const response = await this.$services.justificativaFaltaService.portalAluno(
          pageNumber,
          this.search,
          this.$route.query.matricula_id
        );
        this.paginate = response;
        this.justificativas = response.data;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.carregando = false;
      }
    },
    destroy(id) {
      this.$modals.danger({
        title: "Cuidado!",
        message: "Tem certeza que deseja excluir esta justificativa?",
        confirmationCode: id,
        confirmationMessage: `Por favor, digite <strong>${id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => this.$modals.close(),
            props: { color: "warning", small: true },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              try {
                await this.$services.justificativaFaltaService.destroy(id);
                this.$toast.success("Justificativa excluída com sucesso");
                this.loadData(this.pageNumber);
              } catch (error) {
                this.$handleError(error);
              }
            },
            props: { color: "error", small: true },
          },
        ],
      });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>
